export enum BankAccountType {
  CUENTA_CLABE = 'CUENTA_CLABE',
  CUENTA_CORRIENTE = 'CUENTA_CORRIENTE',
  CUENTA_VISTA = 'CUENTA_VISTA',
  CUENTA_AHORRO = 'CUENTA_AHORRO',
}
